import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { createRef, useMemo } from 'preact/compat';
import { useCallback, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { forgotPasswordSchema } from '@widgets/ForgotPassword/validation/schema';
import { yupResolver } from '@hookform/resolvers/yup';
import API from '@widgets/shared/API/connection';
import TextInput from '@widgets/shared/components/form-controls/TextInput';
import convertDataAttributes from '@widgets/shared/convertDataAttributes';
import FormNotices from '@widgets/shared/components/FormNotices';
function Form(props) {
    const { successUrl, forgotPasswordTitle, forgotPasswordCopy, successTitle, successCopy, successButtonText, successButtonLink, forgotPasswordButtonText, contactCopy, contactEmail, onSuccessButtonClick, } = props;
    const ref = createRef();
    const [errorMessage, setErrorMessage] = useState(undefined);
    const [formCompleted, setFormCompleted] = useState(false);
    const [isRequesting, setIsRequesting] = useState(false);
    const form = useForm({
        mode: 'onChange',
        resolver: yupResolver(forgotPasswordSchema),
        defaultValues: {
            email: '',
        },
    });
    const { formState: { isValid }, handleSubmit, getValues, setError, } = form;
    const handleSubmitEvent = () => {
        setIsRequesting(true);
        const values = getValues();
        const formEl = ref.current;
        API.forgotPassword(values).then((res) => {
            if (res.success === true) {
                setFormCompleted(true);
            }
            else {
                if (res.message) {
                    setErrorMessage(res.message);
                }
                res.errors.forEach((error) => {
                    if (error.field) {
                        setError(error.field, { message: error.message }, {
                            shouldFocus: true,
                        });
                    }
                });
            }
        })
            .finally(() => {
            setIsRequesting(false);
        });
    };
    const handleNoticeClose = useCallback(() => {
        setErrorMessage(undefined);
    }, []);
    return (_jsxs(FormProvider, { ...form, children: [!formCompleted && (_jsxs("div", { className: "form__section", children: [errorMessage && (_jsx("div", { style: { marginBottom: '1rem' }, children: _jsx(FormNotices, { message: errorMessage, type: "error", handleClose: handleNoticeClose }) })), _jsxs("div", { className: "slab__intro", children: [_jsx("h1", { className: "h3", children: forgotPasswordTitle }), _jsx("p", { children: forgotPasswordCopy })] }), _jsxs("form", { method: "POST", className: "form", noValidate: true, onSubmit: handleSubmit(handleSubmitEvent), children: [_jsx(TextInput, { inputAttrs: {
                                    id: 'ctl00_cphMain_txtEmail',
                                    name: 'email',
                                    type: 'email',
                                }, labelAttrs: {
                                    htmlFor: 'ctl00_cphMain_txtEmail',
                                    text: 'Enter your email address',
                                    isFieldRequired: true,
                                } }), _jsxs("div", { className: "form__actions", children: [_jsx("button", { type: "submit", className: "btn", disabled: !isValid || isRequesting, children: forgotPasswordButtonText }), _jsxs("span", { children: [contactCopy, _jsx("a", { href: `mailto:${contactEmail}`, children: "Contact us" })] })] })] })] })), formCompleted && (_jsxs("div", { className: "form__section", children: [_jsxs("div", { className: "slab__intro", children: [_jsx("h1", { className: "h3", children: successTitle }), _jsx("p", { children: successCopy })] }), _jsxs("div", { className: "form__actions", children: [onSuccessButtonClick && (_jsx("button", { className: "btn", type: "button", onClick: onSuccessButtonClick, children: successButtonText })), !onSuccessButtonClick && (_jsx("a", { className: "btn", href: successButtonLink, children: successButtonText }))] })] }))] }));
}
export default function ForgotPasswordForm(props) {
    const { dataset, onSuccessButtonClick } = props;
    const formattedAttributes = convertDataAttributes(dataset ?? {});
    const formConfig = useMemo(() => ({
        ...formattedAttributes,
        onSuccessButtonClick,
    }), [formattedAttributes]);
    return (_jsx(Form, { ...formConfig }));
}
ForgotPasswordForm.defaultProps = {
    onSuccessButtonClick: undefined,
};
